// Navbar.js
// import { useState } from "react";
import { useTheme } from "../hooks/useTheme";
import Logo from "../assets/images/preload.png";
import { useUser } from "../context/UserContext";
import { useNavigate } from "react-router-dom";

import { IconMoon, IconSunFilled, IconUser, IconTransfer } from "@tabler/icons-react";

const NavbarTop = () => {
  const { theme, setTheme } = useTheme();
  const { userData } = useUser(); // Desestructura userData
  const navigate = useNavigate();
  // Definimos las variables con los iconos para cada tema
  const darkModeIcon = <IconMoon size={24} className="icon icon-1" />;

  const lightModeIcon = <IconSunFilled size={24} className="icon icon-1" />;

  // Asignamos el icono correspondiente según el tema
  const icon = theme === "light" ? darkModeIcon : lightModeIcon;

  return (
    <header className="navbar navbar-expand-md d-print-none">
      <div className="container-xl">
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-menu" aria-controls="navbar-menu" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3">
          <div className="d-flex align-items-center">
            <img src={Logo} width={"50px"} alt="" />
            <span className="font-ecotrans text-verde" style={{ fontSize: "40px" }}>
              Eco
            </span>
            <span className={`font-ecotrans ${theme === "light" ? "text-negro" : "text-white"}`} style={{ fontSize: "40px" }}>
              trans
            </span>
          </div>
        </div>
        <div className="navbar-nav flex-row order-md-last">
          <div className="d-none d-md-flex">
            {userData?.es_superusuario && (
              <a className="btn btn-sm btn-secondary btn-pill" href="../../admin/AdminHome" target="_self" rel="noreferrer">
                <span className="nav-link-icon d-md-none d-lg-inline-block icon-pulse">
                  <IconTransfer size={24} className="icon icon-1" />
                </span>
                <span className="nav-link-title">Cambiar Admin</span>
              </a>
            )}
            <button className="nav-link px-0" onClick={() => setTheme(theme === "light" ? "dark" : "light")}>
              {icon}
              {theme === "light"}
            </button>
          </div>
          <div className="nav-item dropdown">
            <button className="nav-link d-flex lh-1 text-reset p-0 bg-transparent border-bottom border-white" data-bs-toggle="dropdown" aria-label="Open user menu">
              <span className="avatar avatar-sm">
                <IconUser size={24} className="icon icon-tabler icons-tabler-outline icon-tabler-user" />
              </span>
              <div className="d-none d-xl-block ps-2">
                {userData && (
                  <div>
                    {userData.forename} {userData.surname}
                  </div>
                )}
                {userData && <div className="mt-1 small text-secondary">{userData.address.town}</div>}
              </div>
            </button>
            <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
              <div className="dropdown-divider"></div>
              {/* <a href="Logout" className="dropdown-item text-danger">
                Cerrar sesión
              </a> */}
              <button onClick={() => navigate("/Logout")} className="dropdown-item text-danger">
                Cerrar sesión
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default NavbarTop;
